import { Button, GenericSuspense, List, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useBankListSort } from "../hooks/useBankListSort";
import { BanksQuery } from "../queries/BanksQuery";
import { TBankInformation } from "@bsm/graphql";
import { BankListItem } from "../components/BankListItem";
import { Link, Outlet } from "react-router-dom";

export const BankListContainer = () => {

    const [ADD] = useTranslations(i18n)
    const urlParams = useUrlParamsValueToString()
    const sortItems = useBankListSort()

    return (
        <div>
            <div className="flex justify-between mb-4">
                <h3 className="font-semibold">Banks</h3>
                <Link to={`-1?${urlParams}`}>
                    <Button
                        className="btn-default"
                        startIcon="fa-solid fa-plus"
                        label={ADD}
                    />
                </Link>
            </div>

            <List
                id={BANK_LIST_ID}
                sort={{ items: sortItems }}
                selection={false}
                isUrlParamsState={false}
                GQLRequest={BanksQuery}
                defaultFilter={{
                    pageSize: 50,
                    page: 0,
                    sort: [{ value: "updatedAt", sort: "DESC" }],
                }}
                onRenderRow={(row: TBankInformation) => (
                    <BankListItem {...row} />
                )}
            />

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    );
};

export const BANK_LIST_ID = "bank-list";

const i18n = [
    'std_add'
];
